import React from 'react';
import WizardMain from 'components/WizardMain';
import i18n from 'i18n';
import useTitle from 'utils/hook/useTitle';

export const WizardMainPage = () => {
  useTitle(i18n.t('BTY_W_T_WELCOME'));

  return <WizardMain />;
};

export default WizardMainPage;
